import {Component, computed, input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {SvgIconComponent} from '../svg-icon/svg-icon.component';

@Component({
  selector: 'app-custom-input',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, SvgIconComponent],
  templateUrl: './custom-input.html',
  styleUrl: './custom-input.scss'
})
export class CustomInput {
  label = input<string>('');
  type = input<string>('text');
  showIcon = input<boolean>(false);
  iconSource = input<string>('');
  placeholder = input<string>(' ');
  isLabelFixed = input<boolean>(false);
  control = input<FormControl>(new FormControl());
  inputId = input<string>('');
  required = input<boolean>(false);

  /**
   * Valore dell'attributo `autocomplete` dell'input.
   *
   * Default `'on'`: il comportamento storico del widget, che va bene per i
   * campi anagrafici dove il riempimento automatico è un aiuto.
   *
   * Sui campi password va invece passato `'new-password'`, l'unico valore che
   * i browser rispettano per NON proporre le credenziali salvate: `'off'` viene
   * deliberatamente ignorato dai gestori di password.
   */
  autocomplete = input<string>('on');

  // Generato una sola volta alla costruzione, non a ogni ricalcolo del segnale
  private readonly _generatedId = `custom-input-${Math.random().toString(36).substring(2, 9)}`;

  readonly uniqueId = computed(() => this.inputId() || this._generatedId);
}
